export default __webpack_public_path__ + "static/logo-white-fbbf570c0ca48c98a95dc04f492dd119.svg";